import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=1c366db2&"
import script from "./Products.vue?vue&type=script&lang=ts&"
export * from "./Products.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports